import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { NgxExtendedPdfViewerService } from "ngx-extended-pdf-viewer";
import { v4 as uuidv4 } from "uuid";
import {
  DEEventEmitterBo,
  DynamicClientFormSaveBO,
  GenerateDynamicClientEmployeeFormBO,
} from "../client-employee-dynamicform.model";
// import { CommonApiService } from "src/app/commonapiservice";
import { lovDropdown } from "../../lov/lov.model";
import { log } from "console";
import { CommonHttpService } from "src/app/common.service";

@Component({
  selector: "app-client-employee-dynamicform-edit",
  templateUrl: "./client-employee-dynamicform-edit.component.html",
  styleUrls: ["./client-employee-dynamicform-edit.component.scss"],
})
export class ClientEmployeeDynamicformEditComponent implements OnInit {
  isDisabled:boolean=false;
  @ViewChild('modalElement', { static: false }) modalElement: ElementRef;
  dynamicFormTemplateType: any = [];
  @Input() EditCEInputProperty: DEEventEmitterBo = new DEEventEmitterBo();
  @Output() EditOutputCE = new EventEmitter<DEEventEmitterBo>();
  saveBo: DynamicClientFormSaveBO = new DynamicClientFormSaveBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  FileURl: any;
  generateDynamicFormBO: GenerateDynamicClientEmployeeFormBO =
    new GenerateDynamicClientEmployeeFormBO();
  dynamicFormTemplateId: string = "";
  entityTypeCode: string;
  name: string;
  Output: any = "";
  templateName: string = "";
  selectrole: any;
  GroupFilter: any;
  GroupNameList: any;
  Clients: any[] = [];
  constructor(
    private ngxService: NgxExtendedPdfViewerService,
    public global: GlobalComponent,
    public CommonAPI: CommonHttpService,
    public toasterService: ToastrService
  ) {
  }
  ngOnInit(): void {
    this.GroupFilter = null;
    this.generateDynamicFormBO.templateId = null;
    this.selectrole = "agency";
    // this.getDynamicFormTemplateDropDown('');
    this.getClientsByEmpId();
    document.getElementById('openTemplateModal').click()
    // if (this.modalElement) {
    //   // Your logic to manipulate the modal element

    // } else {
    //   console.error('Modal element is not available.');
    // }

    this.GroupDocumentDropdown();
  }

  // ngAfterViewInit(): void {
  //   if (this.modalElement) {

  //     // this.initializeModal();
  //     document.getElementById('openTemplateModal').click()
  //   } else {
  //     console.error('Modal element is not available.');
  //   }
  // }


  //................................................clearModal....................................
  saveEditedPdf() {
    if (this.EditCEInputProperty.details.Dynamictype == "Client") {
      this.saveDynamicClientForm();
    } else if (this.EditCEInputProperty.details.Dynamictype == "Employee") {
      this.saveDynamicEmployeeForm();
    }
  }
  //................................................saveDynamicClientForm...........................................
  async saveDynamicClientForm() {
    this.isDisabled=true;
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
    let fileName: any;
    fileName = "Dynamicclientform" + uuidv4().replace(/-/g, "") + ".pdf";
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("clientId", this.EditCEInputProperty.details.Id.toString());
    Formdata.append(
      "dynamicFormTemplateId",
      this.generateDynamicFormBO.templateId
    );
    Formdata.append("file", file);
    let url = "api/DynamicClientForm/saveDynamicClientForm";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(Formdata, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isDisabled=false;
          this.toasterService.success("Form saved successfully");
          document.getElementById("openTemplateModal").click();
          document.getElementById("openPdfModal").click();
          this.closeEdit();
        },
        (err: any) => {
          this.isDisabled=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //................................................saveDynamicClientForm...........................................
  closeEdit() {
    this.EditCEInputProperty.isCreate = false;
    this.EditCEInputProperty.isClose = false;
    this.EditOutputCE.emit(this.EditCEInputProperty)
  }
  //................................................saveDynamicClientForm...........................................
  async saveDynamicEmployeeForm() {
    this.isDisabled=true;
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
    const fileName = "DynamicEmployeeform" + uuidv4().replace(/-/g, "") + ".pdf";
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("employeeId", this.EditCEInputProperty.details.Id.toString());
    Formdata.append(
      "dynamicFormTemplateId",
      this.generateDynamicFormBO.templateId
    );
    Formdata.append("file", file);
    Formdata.append("clientId", this.generateDynamicFormBO.clientId);
    let url = "api/DynamicEmployeeForm/saveDynamicEmployeeForm";

    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(Formdata, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isDisabled=false;
          this.toasterService.success("Form saved successfully");
          // document.getElementById("openTemplateModal").click();
          document.getElementById("openTemplateModal").click();
          document.getElementById("openPdfModal").click();
          this.closeEdit();
        },
        (err: any) => {
          this.isDisabled=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  generateDynamicForms() {
    if (this.EditCEInputProperty.details.Dynamictype == "Client") {
      this.generateDynamicClientForm();
    } else if (this.EditCEInputProperty.details.Dynamictype == "Employee") {
      this.generateDynamicEmployeeForm();
    }
  }
  //................................................generateDynamicClientForm...........................................
  generateDynamicClientForm() {
    let payload = {
      clientId: this.EditCEInputProperty.details.Id,
      templateId: this.generateDynamicFormBO.templateId,
    };
    let url = "api/DynamicClientForm/generateDynamicClientForm";
    this.CommonAPI.saveorUpdateFunctionResponseTypeAsBlob(payload, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          let file = new Blob([data], { type: "application/pdf" });
          this.FileURl = file;
          console.log(this.FileURl, "this.FileURl")
          document.getElementById("openPdfModal").click();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //................................................generateDynamicEmployeeForm...........................................
  generateDynamicEmployeeForm() {
    let payload = {
      employeeId: this.EditCEInputProperty.details.Id,
      templateId: this.generateDynamicFormBO.templateId,
    };
    let url = "api/DynamicEmployeeForm/generateDynamicEmployeeForm";

    this.CommonAPI.saveorUpdateFunctionResponseTypeAsBlob(payload, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          let file = new Blob([data], { type: "application/pdf" });
          this.FileURl = file;
          console.log(this.FileURl);
          document.getElementById("openPdfModal").click();
        },
        (err: any) => {
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }

  onRoleChange() {
    console.log('Role changed to:', this.selectrole);
    this.cleardata();
  }
  // ................................................getDynamicFormTemplateDropDown.............................................
  getDynamicFormTemplateDropDown(GroupFilter) {
    console.log(GroupFilter)
    this.dynamicFormTemplateType = [];
    this.generateDynamicFormBO.templateId = "";
    let params = new URLSearchParams();
    if (this.EditCEInputProperty.details.Dynamictype == "Client") {
      params.append("entityTypeCode", "CLIENT");
    } else if (this.EditCEInputProperty.details.Dynamictype == "Employee") {
      params.append("entityTypeCode", "EMPLOYEE");
    }
    params.append(
      "AgencyId",
      this.selectrole == "agency" ? this.global.globalAgencyId : ''
    );
    params.append("groupNameLid", GroupFilter);

    let url = "api/DynamicForm/getDynamicFormTemplateDropDown?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.dynamicFormTemplateType = data;
        },
        (err: any) => {
          this.toasterService.error("error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }
  selectTemplate(value) {
    // if(value==null||value==undefined||value==''){
    //   this.generateDynamicFormBO.templateId=null;
    // }else{
    this.getDynamicFormTemplateDropDown(value)
    // }
  }
  GroupDocumentDropdown() {
    // document.getElementById('openTemplateModal').click();
    let params = new URLSearchParams();
    if (this.EditCEInputProperty.details.Dynamictype.toUpperCase() == 'CLIENT') {
      params.append("ListCode", "DYNAMICTEMPLATECLIENTONBOARDGROUP");
    }
    else if (this.EditCEInputProperty.details.Dynamictype.toUpperCase() == 'EMPLOYEE') {
      params.append("ListCode", "DYNAMICTEMPLATEEMPLOYEEONBOARDGROUP");
    };
    if (this.selectrole == 'agency') {
      var url = "api/Lov/GetLovDropDown?";
    }
    else {
      var url = "api/Lov/getGlobalLov?";
    }

    //  params.append("userId", this.global.userID);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupNameList = data;
      this.GroupFilter = data?.find(d => d.lovCode.trim().toUpperCase() == 'ONBOARDING')?.id;
      if(this.GroupFilter != null && this.GroupFilter != "00000000-0000-0000-0000-000000000000" && this.GroupFilter != undefined) {
        this.selectTemplate(this.GroupFilter);
      }


    })
  }
  cleardata() {
    this.GroupFilter = null;
    this.generateDynamicFormBO.templateId = null;
    console.log(this.selectrole, "selectrole");

    this.GroupDocumentDropdown();
    // this.selectTemplate('');
  }

  getClientsByEmpId() {
    let params = new URLSearchParams();
    params.append("EmployeeId", this.EditCEInputProperty.details.Id.toString());
    let url = "api/EmployeeDetailsRelation/GetEmployeeClientList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Clients = data;
    })
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
